import styled from 'styled-components';
import { Link } from 'gatsby';

import { colors, fonts, metrics } from '@/theme';

const { mobile } = metrics;

export const Header = styled.div`
  margin: 0 0 60px 0;
  border-top: solid 1px ${colors.black};
  padding-top: 44px;
  display: flex;
  justify-content: space-between;
  @media (max-width: ${mobile}px) {
    flex-direction: column-reverse;
    border-top: none;
    border-bottom: 1px solid ${colors.black};
    margin: 0;
    padding-top: 0;
  }
`;

export const Title = styled.h1`
  ${fonts.getTitle()};
  margin-top: 0;
  opacity: ${() => (typeof window === 'undefined' ? 0 : 1)};
  @media (max-width: ${mobile}px) {
    margin: 10px 0 50px 0;
  }
`;

export const Menu = styled.div`
  display: flex;
  @media (max-width: ${mobile}px) {
    display: none;
    padding: 10px 0 20px 0;
    border-bottom: 1px solid ${colors.black};
  }
`;

export const Wrap = styled.div`
  opacity: ${({ selected }) => (selected ? 0.3 : 1)};
`;

export const MenuItem = styled(Link)`
  ${fonts.getSubTitle(true)};
  margin-bottom: 1em;
  margin: 20px 0 0 70px;
  text-decoration: none;
  color: ${colors.black};
  @media (max-width: ${mobile}px) {
    width: 50%;
    color: ${colors.black};
    ${fonts.getRegularText()}
    margin: 0;
    ${({ selected }) => selected && 'display: none;'}
  }
`;

export const Introduction = styled.p`
  ${fonts.getSubTitle(true)};
  margin-bottom: 1em;
  @media (max-width: ${mobile}px) {
    margin: 20px 0 0 0;
    ${({ amount }) => fonts.getRegularText(amount > 1)}
    & + & {
      margin: 0 0 20px 0;
      ${fonts.getRegularText()}  
    }
  }
`;

export const InvestorProfile = styled.div`
  display: flex;
  @media (max-width: ${mobile}px) {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  max-width: 600px;
  margin-right: 30px;
  @media (max-width: ${mobile}px) {
    margin: 0 0 20px 0;
  }
`;

export const SubTitle = styled.p`
  ${fonts.getRegularText(true)};
  margin: 0;
`;

export const Text = styled.p`
  ${fonts.getRegularText()};
  margin: 0;
`;

export const List = styled.ul`
  list-style-position: outside;
  padding-left: 20px;
  margin: 0;
`;

export const ListItem = styled.li`
  ${fonts.getRegularText()};
`;
